export default __webpack_public_path__ + "static/media/CardImg.e314f527.png";